import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { DreamSearchProgramItems } from "./DreamSearchProgramItems";
import { DreamSearchViewerResults } from "@portal/app/_common/types/dreamSearch";
import { MixpanelEventName } from "@portal/app/_common/types/mixpanel";

export const DreamSearchResultsCarousel = ({
  items,
  eventName,
  programHeadingComponent,
}: {
  items: DreamSearchViewerResults;
  eventName: MixpanelEventName;
  programHeadingComponent?: "h3" | "span";
}) => (
  <Carousel>
    <CarouselSlider className="carousel_slider">
      <DreamSearchProgramItems
        items={items}
        eventName={eventName}
        programHeadingComponent={programHeadingComponent}
      />
    </CarouselSlider>
  </Carousel>
);

export const Carousel = styled(Box)`
  overflow-x: scroll;
  margin: auto;
  width: fit-content;
  max-width: 100%;
`;

export const CarouselSlider = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: fit-content;

  & > * {
    width: 20rem;
    flex: none;
  }
`;
